<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <router-link to="/allServicePartners">All Service Partners</router-link>
        </li>
        <li class="active">
          Deleted List
        </li>
      </ol>
      <div class="row">
        <div class="col-md-12">
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
                @keyup.enter="getAllUsers(1)"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllUsers(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <button class="btn btn-primary submitbtn btn-raised" @click="$router.push('/allServicePartners')">
              Active List
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button type="button" class="btn btn-default">
            New KYC Request&nbsp;<span class="badge">{{ NewVerificationCount }}</span>
          </button>
          <button type="button" class="btn btn-default">
            Total Inactive Service Partners&nbsp;<span class="badge">{{ users_data.length }}</span>
          </button>
        </div>

        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Partner ID</th>
                    <th>User Type</th>
                    <th>Partner Name</th>
                    <th>Address</th>
                    <th>PIN Code</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Total Points Accumulated</th>
                    <th>Point Balance</th>
                    <th>Total Points Redeemed</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: getEditRoute(item.PartnerType),
                          params: { partner_id: item.UserCode },
                        }"
                      >
                        {{ item.UserCode }}
                      </router-link>
                    </td>
                    <td>
                      <span class="label label-info" style="font-size: 11px; padding: 3px 7px;">
                        {{ item.PartnerType | formatPartnerType }}
                      </span>
                    </td>
                    <td>{{ item.first_name | removeNull }} {{ item.last_name | removeNull }}</td>
                    <td>{{ item.AddressLine1 | removeNull }} {{ item.AddressLine2 | removeNull }}</td>
                    <td>{{ item.ZIP | removeNull }}</td>
                    <td>{{ item.State | removeNull }}</td>
                    <td>{{ item.selectedCity | removeNull }}</td>
                    <td>{{ item.TotalPoints | removeNull }}</td>
                    <td>{{ (item.TotalPoints - item.RedeemptionPoints) | setnullZero }}</td>
                    <td>{{ item.RedeemptionPoints | setnullZero }}</td>
                    <td>
                      <a href="#" @click.prevent="ActivateEmployee(item.id)">
                        Activate
                      </a>
                    </td>
                  </tr>
                  <tr v-if="users_data.length === 0">
                    <td colspan="12" class="text-center">No records found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllUsers"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                v-model="refreshPageState"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../../services/common-services';

export default {
  name: 'AllServicePartnersDeleted',
  components: {
    Paginate,
  },
  data() {
    return {
      refreshPageState: 1,
      users_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 0,
      NewVerificationCount: 0,
      VerifiedCount: 0,
      SuccessMessage: '',
      ErrorMessage: '',
    };
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
    this.getAllUsers(this.refreshPageState);
  },
  methods: {
    getEditRoute(type) {
      if (!type) return 'editReborer';
      switch (type) {
        case 'Mechanics':
        case 'Mechanic':
          return 'editMechanic';
        case 'Grinder':
          return 'editGrinder';
        case 'ReborerPlusGrinder':
          return 'editGrinderReborer';
        case 'Reborer':
        default:
          return 'editReborer';
      }
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      if (searchText) {
        params['searchText'] = searchText;
      }
      if (page) {
        params['page'] = page - 1;
      }
      if (pageSize) {
        params['size'] = pageSize;
      }
      params['active'] = "0";
      params['partnerType'] = 'all';
      return params;
    },
    getAllUsers(pageNum) {
      let loader = this.$loading.show();
      this.refreshPageState = pageNum || 1;
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/Reborer/list', params)
        .then((response) => {
          const {
            users_data,
            currentPage,
            TotalPage,
            NewVerificationCount,
            VerifiedCount,
          } = response.data;
          this.users_data = users_data || [];
          this.TotalPage = TotalPage || 1;
          this.currentPage = parseInt(currentPage) || 0;
          this.NewVerificationCount = NewVerificationCount || 0;
          this.VerifiedCount = VerifiedCount || 0;
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
        })
        .finally(() => {
          setTimeout(() => { loader.hide(); }, 500);
        });
    },
    ActivateEmployee(id) {
      if (confirm('Do you want to continue?')) {
        let params = "id=" + id;
        commonServices
          .delete('kspgAPI/BrandEmployee', params)
          .then((response) => {
            this.SuccessMessage = response.data.message || response.data.Messaage;
            if (response.data.status) {
              this.getAllUsers(this.refreshPageState);
            }
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
              this.$router.push({ name: 'login' });
            }
            this.ErrorMessage =
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              e.toString();
          })
          .finally(() => {
            setTimeout(() => (this.SuccessMessage = false), 5000);
            setTimeout(() => (this.ErrorMessage = false), 5000);
          });
      }
    },
  },
  filters: {
    removeNull(data) {
      if (!data) return '';
      return data;
    },
    setnullZero(data) {
      if (!data) return '0';
      return data;
    },
    formatPartnerType(type) {
      if (!type) return '';
      switch (type) {
        case 'Mechanics':
          return 'Mechanic';
        case 'ReborerPlusGrinder':
          return 'Grinder Reborer';
        default:
          return type;
      }
    },
  },
};
</script>

<style scoped>
.visibility {
  visibility: visible !important;
}
.btn-primary {
  background-color: #007bff !important;
  color: #fff !important;
  border: none;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #0056b3 !important;
  color: #fff !important;
  border: none;
}
</style>
